import {useLazyQuery} from "@apollo/client";
import {SyntheticEvent} from "react";
import {toast} from "react-hot-toast";
import {Link, useLocation} from "react-router";

import Button from "@/components/button/Button.tsx";
import {useCopyToClipboard} from "@/lib/hooks/useCopyToClipboard.ts";
import {GQL_PS_REPORT_DATA, GQL_PS_SHARE_URL, PSShareURL} from "@/lib/queries/pagespeed.ts";

interface PSReportMainActionsProps {
  id: number;
  className?: string;
  onRefetch?: SyntheticEvent;
}
export const PSReportMainActions = ({id, className}: PSReportMainActionsProps) => {
  const location = useLocation();
  const [, copy] = useCopyToClipboard();
  const [getShareURL, {data: spData}] = useLazyQuery<PSShareURL>(GQL_PS_SHARE_URL, {
    variables: {
      id: id,
    },
  });

  return (
    <div className={className}>
      {spData?.spShareURL.url && (
        <div className="my-3">
          <strong>Report Public URL: </strong>
          {spData?.spShareURL.url}
        </div>
      )}
      <div className="align-items-center row my-4">
        {spData?.spShareURL.url && (
          <div className="col-md-6 mt-3">
            <Button
              className="w-100"
              onClick={async () => {
                if (spData?.spShareURL.url) {
                  await copy(spData?.spShareURL.url);
                  toast.success("Copied to clipboard!");
                }
              }}
            >
              Copy Public URL
            </Button>
          </div>
        )}
        {!spData?.spShareURL.url && (
          <div className="col-md-6 mt-3">
            <Button
              className="w-100"
              onClick={async () => {
                await getShareURL();
              }}
            >
              Share Check Analysis
            </Button>
          </div>
        )}
        <div className="col-md-6 mt-3">
          <Button
            variant="secondary"
            className="w-100"
            onClick={() => {
              setTimeout(() => {
                window.print();
              }, 300);
            }}
          >
            Download PDF
          </Button>
        </div>
        <div className="col-md-12 my-2">
          <Button
            as={Link}
            state={{
              refetchQueries: [GQL_PS_REPORT_DATA],
              from: location,
            }}
            to={`/checks/${id}/edit`}
            variant="secondary"
            className="w-100"
          >
            Edit Check
          </Button>
        </div>
      </div>
    </div>
  );
};
